'use strict';

var MarketGridsDirective = function MarketGridsDirective() {
  return {
    restrict: 'E',
    controller: 'MarketGridsController',
    template: require('../templates/market-grids.html'),
    scope: {
      demandManagementData: '=',
      reoptPreviewData: '='
    },
    link: function link($scope) {
      $scope.$on('$destroy', $scope.resetMarketDataRetrievers);
      $scope.$on('grid:rowSelectionChanged', $scope.rowSelectionHandler);
      $scope.$on('market-product-group:goToServiceTab', $scope.goToServiceTab);
      $scope.$on('grid:afterUpdateBoundData', $scope.applyCcmChangesToServiceGrid);
      $scope.$watch('selected.tab', $scope.selectedTabChanged);
      $scope.$watch('demandManagementData.main', $scope.demandManagementDataChanged);
      var flightGrids = ['demandManagementData.cabins', 'demandManagementData.classes', 'demandManagementData.segmentClasses', 'demandManagementData.serviceClasses'];
      $scope.$watchGroup(flightGrids, $scope.upperGridsSelectedClassesChanged);
    }
  };
};
MarketGridsDirective.$inject = [];
module.exports = MarketGridsDirective;